import * as React from 'react'; // eslint-disable-line
import dayjs, { Dayjs } from 'dayjs';
import { AccountCell } from '../account-cell/account-cell';

interface HeaderCellProps {
    dataId: string;
    month: Dayjs;
    financialYearStartMonth: number;
}

export const HeaderCell = ({ dataId, month, financialYearStartMonth }: HeaderCellProps) => {
    return (
        <th
            data-month={month.format('M')}
            data-fy={
                month.isBefore(dayjs(`${month.year()}-${financialYearStartMonth}`).format('YYYY-MM'))
                    ? month.subtract(1, 'year').format('YYYY')
                    : month.format('YYYY')
            }
            data-test-id={`${dataId}`}
        >
            <AccountCell isHeader>{month.format('MMM YY')}</AccountCell>
        </th>
    );
};
